export enum DateFilter {
    TODAY = 'today',
    YESTERDAY = 'yesterday',

    CURRENT_WEEK = 'currentWeek',
    LAST_WEEK = 'lastWeek',
    CURRENT_MONTH = 'currentMonth', 
    LAST_MONHTH = 'lastMonth', 

    CURRENT_QUARTER = 'currentQuarter', 
    LAST_QUARTER = 'lastQuarter', 

    CURRENT_FINANCIAL_YEAR = 'currentFinancialYear', 
    LAST_FINANCIAL_YEAR = 'lastFinancialYear', 
    CUSTOM = 'custom'
}